import { createSlice } from '@reduxjs/toolkit';

const requestsSlice = createSlice({
    name: 'requests',
    initialState: {
        requestsList: null,
        actualRequest: null,
        requestMode: null,
    },
    reducers: {
        setRequestsList: (state, action) => {
            state.requestsList = action.payload;
        },
        addRequest: (state, action) => {
            state.requestsList = [...state.requestsList, action.payload];
        },
        deleteRequestAction: (state, action) => {
            state.requestsList = state.requestsList.filter(request => request.id !== action.payload);
        },
        setActualRequest: (state, action) => {
            state.actualRequest = action.payload;
        },
        setRequestMode: (state, action) => {
            state.requestMode = action.payload;
        }
    }
})

export const { setRequestsList, addRequest, deleteRequestAction, setActualRequest, setRequestMode } = requestsSlice.actions;
export default requestsSlice.reducer;
